import { useContext } from 'react'

import { ProfileWidgetsExpandContext } from '../../../../context'

export function useProfileWidgetsExpandContext() {
  return useContext(ProfileWidgetsExpandContext)
}
